const ListRow = ({ name, actionCheckBox, actionsNode, children }) => {
  return (
    <div className="pb-2 mb-2 mt-2 border-b-2 border-blue-700">
      <div className="flex text-sm items-center">
        {actionCheckBox}
        <p className="w-full text-grey-darkest">{name}</p>
        {actionsNode}
      </div>
      {children}
    </div>
  );
};

const ListRowPlaceholder = () => {
  return (
    <div className="animate-pulse flex items-center mb-4 pb-3 border-b-2 border-blue-700">
      <div className="rounded h-8 w-10 mr-2 bg-gray-400"></div>
      <div className="rounded h-8 w-full mr-2 bg-gray-400"></div>
      <div className="rounded h-8 w-10 mr-2 bg-gray-400"></div>
    </div>
  );
};

const SingleRowPlaceholder = () => {
  return (
    <div className="animate-pulse flex items-center border-b-2 border-blue-700">
      <div className="rounded h-8 w-full mr-2 bg-gray-400"></div>
    </div>
  );
};

export { ListRow, ListRowPlaceholder, SingleRowPlaceholder };
